import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

const edit = {
	SnPzn: null as string | null,
	VyrobekvozOzn: null as string | null,
	SnDruh: null as string | null,
	SnNrSubstPrp: null as boolean | null,
	Text: null as string | null,
	SnzdrojdatPzn: null as string | null,
	EditPrp: null as boolean | null,
	SlevacelkPrp: null as boolean | null,
	SnrozpisPzn: null as string | null,
	SnppcentvPzn: null as string | null,
	SnndcentvPzn: null as string | null,
	SlevaSlz: null as number | null,
	SlevaMat: null as number | null,
	PlatnostDat: null as Date | null,
	PlatnostdoDat: null as Date | null,
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		SnPzn: [],
		VyrobekvozOzn: [],
		SnDruh: [],
		SnzdrojdatPzn: [],
		SnrozpisPzn: [],
		SnppcentvPzn: [],
		SnndcentvPzn: [],
	},
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
